import {
  Table,
  Space,
  Typography,
  Card,
  Button,
  Dropdown,
  Checkbox,
  Input,
  Tabs
} from "antd";
import {
  CarOutlined,
  UserOutlined,
  EnvironmentOutlined,
  AppstoreOutlined,
  DashboardOutlined,
  EnvironmentFilled,
  FieldTimeOutlined,
  EyeOutlined,
  GlobalOutlined,
  ExportOutlined
} from "@ant-design/icons";
import "./rapportVehiculeCourses.scss";
import {
  ChronoBox,
  EcartBox,
  MoyenneBox,
  TooltipBox,
  TooltipCell,
  TooltipWrapperBox,
} from "../../../../../utils/renderTooltips";
import VehicleSpeed from "../../../../../utils/vehicleSpeed";
import { VehicleAddress } from "../../../../../utils/vehicleAddress";
import { useState, useMemo } from "react";
import RapportVehiculeCoursesCarte from "../../../rapportCharroi/rapportVehiculeCourses/rapportVehiculeCoursesCarte/RapportVehiculeCoursesCarte";
import TrueBonDeSortie from "../../trueBonDeSortie/TrueBonDeSortie";

const { Text } = Typography;

const RapportVehiculeCourses = ({ course }) => {
  const hasSpeed = course?.some((r) => r?.capteurInfo?.speed !== undefined);
  const [searchText, setSearchText] = useState("");
  const [activeKey, setActiveKey] = useState("1");
  const handleTabChange = (key) => {
    setActiveKey(key);
  };

  const baseColumns = [
    {
      title: "#",
      key: "index",
      render: (_, __, index) => (
        <Text style={{ fontSize: 18, fontWeight: 600, color: "#000" }}>{index + 1}</Text>
      ),
      width: 70,
      align: "center",
      fixed: "left",
      alwaysVisible: true,
    },
    {
      title: (
        <Space>
          <AppstoreOutlined style={{ color: "#1890ff", fontSize: 20 }} />
          <Text strong style={{ fontSize: 16, color: "#333" }}>Motif</Text>
        </Space>
      ),
      dataIndex: "nom_motif_demande",
      key: "nom_motif_demande",
      render: (text) => <TooltipBox text={text} bg="#f0f0f0" color="#000" />,
      width: 150,
      alwaysVisible: true,
    },
    {
      title: (
        <Space>
          <UserOutlined style={{ color: "orange", fontSize: 20 }} />
          <Text strong style={{ fontSize: 16, color: "#333" }}>Chauffeur</Text>
        </Space>
      ),
      dataIndex: "nom",
      key: "nom",
      render: (_, record) => (
        <TooltipCell
          cellText={record.prenom_chauffeur}
          tooltipText={`${record.nom || '-'} ${record.prenom_chauffeur || '-'}`}
          bg="#f0f0f0"
          color="#000"
        />
      ),
      width: 180,
      alwaysVisible: true,
    },
    {
      title: (
        <Space>
          <EnvironmentOutlined style={{ color: "red", fontSize: 20 }} />
          <Text strong style={{ fontSize: 16, color: "#333" }}>Destination</Text>
        </Space>
      ),
      dataIndex: "nom_destination",
      key: "nom_destination",
      render: (text) => <TooltipBox text={text} bg="#f0f0f0" color="#000" maxWidth={250} />,
      width: 200,
      alwaysVisible: true,
    },
    {
      title: (
        <Space>
          <CarOutlined style={{ color: "green", fontSize: 20 }} />
          <Text strong style={{ fontSize: 16, color: "#333" }}>Véhicule</Text>
        </Space>
      ),
      dataIndex: "abreviation",
      key: "abreviation",
      render: (text, record) => (
        <TooltipCell
          cellText={text}
          tooltipText={`Marque : ${record.nom_marque} / Immatriculation : ${record.immatriculation}`}
          bg="#f0f0f0"
          color="#000"
        />
      ),
      width: 130,
      alwaysVisible: true,
    },
    {
      title: (
        <Space>
          <FieldTimeOutlined style={{ color: "#52c41a", fontSize: 20 }} />
          <Text strong style={{ fontSize: 16, color: "#333" }}>Durée R.</Text>
        </Space>
      ),
      key: "duree_reelle_min",
      align: "center",
      render: (_, record) => (
        <ChronoBox sortie_time={record.sortie_time} date_prevue={record.date_prevue} />
      ),
      width: 100,
      alwaysVisible: true,
    },
    {
      title: (
        <Space>
          <FieldTimeOutlined style={{ color: "#faad14", fontSize: 20 }} />
          <Text strong style={{ fontSize: 16, color: "#333" }}>Durée M</Text>
        </Space>
      ),
      key: "duree_moyenne_min",
      align: "center",
      render: (_, record) => <MoyenneBox duree_moyenne_min={record.duree_moyenne_min} />,
      width: 150,
      alwaysVisible: true,
    },
    {
      title: (
        <Space>
          <FieldTimeOutlined style={{ color: "#1890ff", fontSize: 20 }} />
          <Text strong style={{ fontSize: 16, color: "#333" }}>Écart</Text>
        </Space>
      ),
      key: "ecart_min",
      align: "center",
      render: (_, record) => (
        <EcartBox
          duree_reelle_min={record.duree_reelle_min}
          duree_moyenne_min={record.duree_moyenne_min}
        />
      ),
      width: 100,
      alwaysVisible: true,
    },
  ];

  baseColumns.splice(3, 0, {
    title: (
      <Space>
        <EnvironmentFilled style={{ color: "#eb2f96", fontSize: 20 }} />
        <Text strong style={{ fontSize: 16, color: "#333" }}>Position</Text>
      </Space>
    ),
    key: "address",
    render: (_, record) => (
      <TooltipWrapperBox
        tooltipText={record?.capteurInfo?.address || record?.position || "Adresse inconnue"}
        bg="#f0f0f0"
        color="#000"
      >
        <VehicleAddress record={record} />
      </TooltipWrapperBox>
    ),
    width: 160,
    alwaysVisible: true,
  });
  // Ajouter Vitesse si présent
  if (hasSpeed) {
    baseColumns.splice(4, 0, {
      title: (
        <Space>
          <DashboardOutlined style={{ color: "#722ed1", fontSize: 20 }} />
          <Text strong style={{ fontSize: 16, color: "#333" }}>Vitesse</Text>
        </Space>
      ),
      key: "speed",
      align: "center",
      render: (_, record) => (
        <VehicleSpeed
          speed={record?.capteurInfo?.speed || 0}
          engineOn={record?.capteurInfo?.engine_status === true}
        />
      ),
      width: 150,
      alwaysVisible: false,
    });
  }


  const [visibleKeys, setVisibleKeys] = useState(
    baseColumns.filter(c => c.alwaysVisible !== false).map(c => c.key)
  );

  const filteredData = useMemo(() => {
    if (!searchText) return course;
    const lowerSearch = searchText.toLowerCase();
    return course.filter((item) =>
      Object.keys(item).some((key) => 
        item[key] &&
        item[key].toString().toLowerCase().includes(lowerSearch)
      )
    );
  }, [searchText, course]);

  const filteredColumns = useMemo(
    () => baseColumns.filter((col) => visibleKeys.includes(col.key)),
    [visibleKeys, baseColumns]
  );

  const columnOptions = baseColumns.map((c) => ({
    label: c.title.props?.children?.[1]?.props?.children || c.key,
    value: c.key,
  }));

  const dropdownMenu = (
    <div style={{ padding: "10px 15px" }}>
      <Checkbox.Group
        value={visibleKeys}
        onChange={setVisibleKeys}
        options={columnOptions}
      />
    </div>
  );

  

  return (
    <div>
      <Tabs
        activeKey={activeKey}
        onChange={handleTabChange}
        type="card"
        tabPosition="top"
      >
        <Tabs.TabPane
            tab={
            <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <CarOutlined style={{ color: "#1890ff" }} />
              Liste des courses
            </span>
            }
            key="1"
        >
          <div className="rapportVehiculeCourses">
            <Card
              bordered={false}
              title={<Text style={{ fontSize: 18, fontWeight: 600, color: "#333" }}>Rapport des Courses</Text>}
              extra={
                <Space>
                  <Input.Search
                    placeholder="Rechercher..."
                    allowClear
                    onChange={(e) => setSearchText(e.target.value)}
                    style={{ width: 250 }}
                  />
                  <Dropdown
                    overlay={dropdownMenu}
                    trigger={["click"]}
                    placement="bottomRight"
                  >
                    <Button icon={<EyeOutlined />}>Colonnes</Button>
                  </Dropdown>
                </Space>
              }
            >
              <div className="table-scroll">
                <Table
                  columns={filteredColumns}
                  dataSource={filteredData}
                  rowKey={(record) => record.id_vehicule}
                  pagination={{ pageSize: 18 }}
                  scroll={{ x: "max-content" }}
                  bordered={false}
                  size="middle"
                  rowClassName={(record) => (record.en_cours ? "row-en-cours" : "")}
                />
              </div>
            </Card>
          </div>
        </Tabs.TabPane>

        <Tabs.TabPane
          tab={
            <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <ExportOutlined style={{ color: "blue" }} />
              Contrôle des sorties
            </span>
          }
          key="2"
        >
          <TrueBonDeSortie />
        </Tabs.TabPane>

        <Tabs.TabPane
            tab={
              <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <GlobalOutlined style={{ color: "green" }} />
                Localisation
              </span>
            }
            key="3"
        >
          <RapportVehiculeCoursesCarte />
        </Tabs.TabPane>
      </Tabs>    
    </div>
  );
};

export default RapportVehiculeCourses;
